export default "__VITE_ASSET__c6dcb049__"